(function (module) {
    "use strict";

    module.component('chamferingSkuForecast', {
        template: require('./chamferingSkuForecastComponent.html'),
        bindings: {
            parameters: '<',
            stepEnter: "=",
            market: "=",
            sku: '=',
            historicalDataCallback: "&",
            isEditable: "<",
            brand: '<'
        },
        controller: ['synchronousEventsBus', 'monthlyDataService',
            function(
                this: $TSFixMe,
                synchronousEventsBus: $TSFixMe,
                monthlyDataService: $TSFixMe
            ) {
                var $ctrl = this;
                $ctrl.componentMethods = {};

                $ctrl.chamferChanged = () =>
                    synchronousEventsBus.$broadcast('skuChamferingChange', { forecast: $ctrl.sku.forecast, brand: $ctrl.brand, parameters: $ctrl.parameters });

                $ctrl.selectCorrectionAbouFacts = () => $ctrl.componentMethods.enterCorrectionAboutFacts();
            }]
    })

})(angular.module('topline.chamferForecast'));